import './App.css';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Navigation from './components/Navigation';
// import Home from './pages/Home';
// import Projects from './pages/Projects';
// import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
    </div>
  );
}

export default App;
